import React from 'react'

import { Number, Count, Arrows, Button } from './styles'
import { ArrowControllers } from '@icons'

const NumberComponent = ({
  value = 0,
  onChange = () => null,
  name = '',
  countWidth = null,
  inputWidth = null,
  placeholder = '',
}) => {
  const handleChange = value => {
    if (!isNaN(value) && value >= 0) {
      const event = {
        target: {
          name,
          value: parseInt(value, 0),
        },
      }

      onChange(event)
    }
  }

  return (
    <Number width={inputWidth}>
      <Count
        placeholder={placeholder}
        type="number"
        width={countWidth}
        value={value}
        onChange={({ target: { value } }) => handleChange(value)}
        name={name}
      />
      <Arrows>
        <ArrowControllers />
        <Button up onClick={() => handleChange(value + 1)} />
        <Button down onClick={() => handleChange(value - 1)} />
      </Arrows>
    </Number>
  )
}

export default NumberComponent
